import { Injectable } from '@angular/core';
import { UsersActivitiesClient } from '../web-api-client';

@Injectable({
  providedIn: 'root'
})

export class UserActivityService {

  constructor(private userActivityClient: UsersActivitiesClient) {
  }

  async logUserActivity(userAction: string, userId: string, email: string, path: string, taskId: string, processId: string) {
    return await this.userActivityClient.logUserActivity(userAction, userId, email, path, taskId, processId).toPromise();
  }
}
